import angular from 'angular';

import directive from './report-types.directive';
import controller from './report-types.controller';

import reportType from './reportType';

export default angular.module('app.components.reports.archivedReports.reportTypes', [
  reportType
])
  .directive('archivedReportTypes', directive)
  .controller('ArchivedReportTypesController', controller)
  .name;

console.log('app.components.reports.archivedReports.reportTypes created');
